module.exports = __webpack_public_path__ + "static/trintech-thumbnail-a2007d27ba0f894e7b00a50b1dd46c9d.png";